import React from 'react';
import { Route, Routes } from 'react-router-dom';
import WrongPage from './components/404-page/404';
import ErrorTesting from './components/ErrorBoundary/TestError';
import ReactCounter from './components/hooks/useReducerComponent';
import CustomHook from './components/hooks/custom-hooks';
import Home from './Home';

function App() {
  return (
    <section>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/useReducerComponent" element={<ReactCounter />} />
        <Route path="/custom-hooks" element={<CustomHook />} />
        <Route path="/TestError" element={<ErrorTesting />} />
        <Route path="*" element={<WrongPage />} />
      </Routes>
    </section>
  );
}

export default App;
